import styled from 'styled-components';

export const Container = styled.div`
  .ant-tabs-tab {
    border-bottom: none !important;
  }

  .ant-tabs-tab-active {
    background: ${({ theme }) => theme.colors.background} !important;
    border-color: ${({ theme }) => theme.colors.primary} !important;
    color: ${({ theme }) => theme.colors.primary} !important;
  }

  .request-creation-error-table-cell {
    position: relative;

    .ant-table-cell {
      position: static !important;
      border-top: 1px dashed #f7ac95;
      border-bottom: 1px dashed #f7ac95;
      &:first-child {
        padding-left: 40px !important;
        border-left: 1px dashed #f7ac95 !important;
      }
    }
  }
`;
